import { Loading } from "components/Loading/loading";
import { useContext, useEffect, useRef, useState } from "react";
//import { Data } from "./components/data/data";
import { Search } from "components/Search/Search";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import { useLocation, useNavigate } from "react-router-dom";
import { GUID_EMPTY } from "utils/constants";
import { trans } from "utils/helpers";
import { getConstraint, getItemGroupLabels, getItemStoreListApi } from "./api";
import { FilterBox } from "./components/FilterBox/FilterBox";
import { ItemCards } from "./components/ItemCard/ItemCards";
import { ItemCardsHeader } from "./components/ItemCardsHeader/ItemCardsHeader";
import { ItemGroupFilterBox } from "./components/ItemGroupFilterBox/ItemGroupFilterBox";
import { ItemGroupLebal } from "./components/ItemGroupMenu/ItemGroupLabel";
import { ItemGroupLabelSlider } from "./components/ItemGroupMenu/ItemGroupLabelSlider";

interface Form {
  Title: string;
  Status: number;
}
export const ECommercePage = ({ match }) => {
  const [forceUpdate, setForceUpdate] = useState(false);

  const [response, setResponse] = useState<any>();
  const [resetForm, setResetForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ecommrceConstraint,setEcommerceConstraint]=useState<any>()
  const [messageType, setMessageType] = useState<any>("info");
  const [itemGroupId, setItemGroupId] = useState<any>(GUID_EMPTY);
  const [dataGroup, setDataGroup] = useState<any>([]);
  const defaultCardStyle=localStorage.getItem('cardStyle')?JSON.parse(localStorage.getItem('cardStyle') as string):true
  const [cardStyle, setCardStyle] = useState<any>(null);
  const [groupLabels, setGroupLabels] = useState<any>({});
  const [breadCrumb, setBreadCrumb] = useState<any>([
    { id: null, name: trans("ECommerce") },
  ]);
  const itemGroupIdRef = useRef<any>(GUID_EMPTY);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const itemGroup = queryParams.get("itemGroup");
  const [stopFetching, setStopFetching] = useState<any>(false);
  const [filterObj, setfilterObj] = useState<any>("");
  const [filterList, setfilterList] = useState<any>([]);
  const { sidebarIsOpen,emptyBasket ,setLayoutEcommrceConstraint } = useContext(LayoutContext);
  const [search,setSearch]=useState('')
  const boxRef = useRef<any>(null);
  const [showFilterBox,setShowFilterBox]=useState(false)

  const navigate = useNavigate();
  async function getECommerceAsync(
    e = null,
    pagenum = 1,
    minPrice = null,
    maxPrice = null,
    size = 10,
    filterList=[]

  ) {
    if (pagenum <= 1) setLoading(false);

    try {
      const res = await getItemStoreListApi(
        e == GUID_EMPTY ? null : e,
        pagenum,
        minPrice,
        maxPrice,
       boxRef?.current.clientWidth<576?Math.floor((window.innerHeight/171)+1): boxRef?.current ?Math.floor(boxRef?.current?.offsetWidth/208)*Math.floor((((75 / 100) * window.innerHeight)/340)+2):10,
        search,
        filterList.map(item => `ItemName=${item}`).join(",")
      );
      if (pagenum > 1) {
      }
      if (res.Data.PageNumber * res.Data.PageSize >= res.Data.TotalRecords) {
        setStopFetching(true);
      } else {
        setStopFetching(false);
      }
      if (
        res.Data.Data.length == 1 &&
        res.Data.Data[0].Id == GUID_EMPTY &&
        pagenum == 1
      ) {
        setResponse([]);
      } else {
        if (pagenum <= 1) {
          setResponse(res.Data.Data);
        } else {
          if (res.Data.Data[0].Id != GUID_EMPTY) {
            setResponse((pre) => {
              return [...pre, ...res.Data.Data];
            });
          }
        }
      }
      setMessageType("info");
    } catch (error) {
      setMessageType("error");
    }
    if (pagenum <= 1) setLoading(true);
  }
  function handleSearch(e){
    setSearch(e)
  }

  function clickBreadCrumb(Bread) {
    setItemGroupId(Bread.id);
    itemGroupIdRef.current = Bread.id;
    let newBread: any = [];
    let flag = false;
    breadCrumb.map((item) => {
      if (!flag) {
        newBread.push(item);
      }
      if (item.id == Bread.id) {
        flag = true;
      }
    });
    setBreadCrumb(newBread);
  }

const getConstraintAsync=async()=>{
  try{
    const response=await getConstraint()
    setLayoutEcommrceConstraint(response.Data)
    setEcommerceConstraint(response.Data)
    setShowFilterBox(response.Data?.ShowFilter)
  }
  catch(error){}
}

  const getDataAsync = async (id = null) => {
    try {
      const res = await getItemGroupLabels();

      if (id == null) {
        setGroupLabels(res.data);
        let content =
          res.Data &&
          Object.keys({ [GUID_EMPTY]: trans("all"), ...res.Data }).map(
            (item, index) => (
              <ItemGroupLebal
                key={index + "contentECommerce"}
                shape="FoursquareRadio"
                IsActive={itemGroupIdRef.current == item}
                onClick={(e) => {
                  e.stopPropagation();
                  setItemGroupId(item);
                  itemGroupIdRef.current = item;
                  setBreadCrumb([
                    { id: null, name: trans("ECommerce") },
                    {
                      id: item,
                      name: { [GUID_EMPTY]: trans("all"), ...res.Data }[item],
                    },
                  ]);
                }}
                title={{ [GUID_EMPTY]: trans("all"), ...res.Data }[item]}
              />
            )
          );
        setDataGroup(content);
      } else {
        //    const res2 = {Data:{
        //        "E36E1489-83FC-EE11-AB53-00155DAA1053":{
        //            "E36E1489-83FC-EE11-AB53-001552561053": "کلاه",
        //            "E36E1489-83FC-EE11-AB53-001589631053": "کالای چرم",
        //        },
        //        "084E4FDE-6D74-ED11-AB39-00155DAA1053":{
        //            "084E4FDE-6D74-ED11-AB39-0015596A1053": "برق صنعتی",
        //            "084E4FDE-6D74-ED11-8953-00155DAA1053": " برق خانگی",
        //        }
        //
        //    }}
        //    let content =(res2.Data[id]&& Object.keys(res2.Data[id]).map((item,index) =>(<ItemGroupLebal key={index+'contentECommerce'} shape="FoursquareRadio" IsActive={itemGroupId==item} onClick={(e)=>{e.stopPropagation()  ;setItemGroupId(item);setBreadCrumb([...breadCrumb , {id: item,name:res2.Data[id][item]}])}} title={res2.Data[id][item]}/>)))
        //   setDataGroup(content)
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (itemGroup) {
      setItemGroupId(itemGroup);
      itemGroupIdRef.current = itemGroup;
      navigate("/e-commerce/Items", { replace: true });
    } else {
      getECommerceAsync(itemGroupId,1,filterObj.min,filterObj.max,10 ,filterList);
      getDataAsync(null);
    }
  }, [itemGroupId, forceUpdate,search ,filterList]);

  useEffect(()=>{
      emptyBasket && getECommerceAsync(itemGroupId,1,filterObj.min,filterObj.max);
  },[emptyBasket])

  useEffect(() => {
    if (resetForm) {
      setResetForm(false);
    }
  }, [resetForm]);

  useEffect(() => {
    getDataAsync();
    getConstraintAsync()
  }, []);
  useEffect(() => {
  }, [sidebarIsOpen]);

  useEffect(() => {
    if (itemGroupId == null) {
      setfilterObj({});
    }
  }, [itemGroupId]);

  /* #endregion */

  //filter by max and min price


  return (
    <>
    {  ecommrceConstraint?.IsEcommerceClosed	 ?   <div className="text-secondary position-absolute " style={{fontSize:'12px',right:sidebarIsOpen?'53%':'50%'}}>
              {ecommrceConstraint?.IsEcommerceClosedDescription	}
            </div>
            
          :
          <>
      <div
        className="d-flex align-items-center w-100 ecommerce-header"
        style={{ zIndex: "5", flexDirection: "column"}}
      >
        <div
          className="w-100 m-1 h-100 d-flex align-items-center"
          style={{ flexDirection: "row", justifyContent: "space-between" }}
        >
            <div className="col-6 col-sm-4">
            {breadCrumb.map((breadCrumbsItem, index) => (
              <span
                key={index}
                onClick={() => {
                  clickBreadCrumb(breadCrumbsItem);
                }}
                style={{ cursor: "pointer" }}
              >
                {breadCrumbsItem.name}
                {index < breadCrumb.length - 1 ? (
                  <span key={index} className="bread-crumb__separator">
                    /
                  </span>
                ) : null}
              </span>
            ))}
            </div>
            <div className="text-secondary text-center col-6 col-sm-4 " style={{fontSize:'12px',right:sidebarIsOpen?'53%':'50%'}}>
              {trans(ecommrceConstraint?.CurrencyHelp)}
            </div>
      <div className="d-none d-sm-flex col-sm-4  text-start  d-flex align-items-center">
          <ItemCardsHeader
            data={response}

            handleModeCard={(e) => {
              setCardStyle(e)

              ;
            }}
          /></div>
        </div>
         <div className="d-flex d-sm-none col-12  text-end  d-flex align-items-center">
          <ItemCardsHeader
            data={response}
   
            handleModeCard={(e) => {
              setCardStyle(e)
         
              ;
            }}
          /></div>
      </div>
      <div className="card-group">
        {/* <ItemGroupCards /> */}

        <div className={`${!showFilterBox ? 'd-none':'col-lg-2 d-lg-block d-none'}`} style={{maxHeight:'100%'}} >
        <div className="" style={{ width: `${sidebarIsOpen ? "13vw" : "15.8vw"}`,height:'48px' }}>
         <div style={{marginTop:'0.2rem'}}>

         
          <Search
            //   defultSerach={defultSerach}
            //   setIsFocos={setIsFocos}
              isFocos={false}
              onChange={ handleSearch}
              
            />
            </div>
          </div>
        
          <div style={{ width: `${sidebarIsOpen ? "13vw" : "15.8vw"}`  }}>
 
     
           
            {itemGroupId == "E36E1489-83FC-EE11-AB53-00155DAA1053" && (
              <>
                <FilterBox
                  setfilterObj={(e) => {
                    setfilterObj({ ...filterObj, ...e });
                  }}
                  filterData={{
                    type: 2,
                    data: ["طبیعی", "مصنوعی"],
                    title: "بر اساس جنس چرم",
                  }}
                />
                <FilterBox
                  setfilterObj={(e) => {
                    if (filterObj.option2) {
                      setfilterObj({ ...filterObj, ...{ option2: null } });
                    } else {
                      setfilterObj({ ...filterObj, ...e });
                    }
                  }}
                  filterData={{
                    type: 3,
                    data: ["ورزش"],
                    title: "بر اساس کاربرد ",
                  }}
                />
              </>
            )}
            {itemGroupId == "084E4FDE-6D74-ED11-AB39-00155DAA1053" && (
              <>
                <FilterBox
                  setfilterObj={(e) => {
                    setfilterObj({ ...filterObj, ...e });
                  }}
                  filterData={{
                    type: 2,
                    data: ["100-240V AC", "24-220V DC"],
                    title: "بر اساس ولتاژ کاری",
                  }}
                />
                <FilterBox
                  setfilterObj={(e) => {
                    if (filterObj.option2) {
                      setfilterObj({ ...filterObj, ...{ option2: null } });
                    } else {
                      setfilterObj({ ...filterObj, ...e });
                    }
                  }}
                  filterData={{
                    type: 3,
                    data: ["آب بندی شده"],
                    title: "بر اساس آب بندی ",
                  }}
                />
              </>
            )}
          </div>
          
          <div className="card" style={{maxHeight:`${(itemGroupId&& itemGroupId != GUID_EMPTY)?'89%':'auto'}`  }}>
 
  
            <ItemGroupFilterBox
            itemGroupId={itemGroupId}
            setfilterObj={setfilterObj}
            filterObj={filterObj}
              setfilterList={(e) => {
                setfilterList(e);
              }}
              filterData={{ type: 1, title: "بر اساس ویژگی" }}
              handleFilter={()=>{
                if (filterObj.min != null || filterObj.max != null) {
                  getECommerceAsync(itemGroupId, 1, filterObj.min, filterObj.max );
                }
                
              }}
              handleRemoveFilter={()=>{
              
                  getECommerceAsync(itemGroupId, 1,null , null );
                
              }}
            />

          </div>
          
          
        </div>

        <div className={`${!showFilterBox?'col-12':'col-lg-10 col-12 '} item-card-container`} ref={boxRef} >
             <div
            className="row align-items-center h-10 me-0  w-100 p-0"
            style={{ backgroundColor: "#f4f6f9",height:'48px' }}
          >
            <div className={`${!showFilterBox?'col-2':'d-none'}`}>
                <div className="" style={{ width: `${sidebarIsOpen ? "13vw" : "15.8vw"}`,height:'48px' }}>
         <div style={{marginTop:'5px'}}>

         
          <Search
            //   defultSerach={defultSerach}
            //   setIsFocos={setIsFocos}
              isFocos={false}
              onChange={ handleSearch}
              
            />
            </div>
          </div>
            </div>
            <div className={`${!showFilterBox?'col-10':'col-12 '}`}>
            <ItemGroupLabelSlider children={dataGroup} />

            </div>
          </div>
        {loading ? (
            <ItemCards
            ecommrceConstraint={ecommrceConstraint}
              loading={loading}
              stopFetching={stopFetching}
              fetchData={(e, minPrice, maxPrice) => {
                if (e != 1 || (maxPrice != null && minPrice != null))
                  getECommerceAsync(itemGroupId, e, filterObj.min, filterObj.max );
              }}
              itemGroupId={itemGroupId}
              filterId={itemGroupId}
              cardStyle={cardStyle}
              dataGroup={dataGroup}
              data={response}
            />
          ) : (
            <Loading />
          )}
          </div>
      </div></>
          }
    </>
  );
};
